// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"lds-ring__2rnit","centerSpinner":"center-spinner__EM0_E"};